import { render } from "./forklift.konveyor.io.plan.vue?vue&type=template&id=15fcd8fe"
import script from "./forklift.konveyor.io.plan.vue?vue&type=script&lang=js"
export * from "./forklift.konveyor.io.plan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__